import { appBorders, DialogNugget, Tier } from '@backrs_ui/common-ui';

import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';
import { RESULT_PAGE_TOUR_IDS } from '@backrs_ui/grow-ui/src/pages/Result/tour/ResultPage.tour';

import { SxProps, Theme, Dialog, Box } from '@mui/material';

type CareerPathDialogProps = Readonly<{
  careerPathSuggestions: CareerPathWithScore[];
  open: boolean;
  onClose: () => void;
  tier: Tier;
}>;

/**
 *
 * This component is a direct call to the dialog nugget that allows us to keep the Career Path Dialog mounted at render. IntroJs does not work with components mounted after render, which means using the normally dispatched MappedDialogNugget cannot work (since the Ask Lubav buttons are only shown once the nugget is rendered and the career path variant is chosen).
 */
export const CareerPathDialogForTour = ({
  open,
  onClose,
  careerPathSuggestions,
  tier,
}: CareerPathDialogProps) => {
  const { careerPath: architectureCareerPath, scoreSection } =
    careerPathSuggestions.find((careerPath) => careerPath.careerPath.name === 'Architecture') || {};

  const handleApiCall = async () => {
    return {
      response: undefined,
      isError: false,
      loadingButton: undefined,
    };
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" keepMounted sx={dialogStyle}>
      {/* the same ID is used for both step 5 and 6 in the tour */}
      <Box id={RESULT_PAGE_TOUR_IDS.step5}>
        <DialogNugget
          title={architectureCareerPath?.name || ''}
          description={architectureCareerPath?.description || ''}
          variant={{
            isDialogOpen: open,
            type: 'career-path',
            title: 'Career Path',
            careerPathInfo: architectureCareerPath || null,
            tier,
            askLubavButtonGroupProps: {
              isDialogOpen: open,
              tier,
              handleApiCall,
              enableAllOptions: true,
              user: undefined,
            },
            apiKeyOnClick: [
              {
                key: 'career-track/requirements-to-succeed',
                onClick: () => null,
                actionButtonText: 'Markers of Success',
              },
            ],
          }}
          columnCategory={'Career Path'}
          saveToLibrary={() => null}
          shareParams={{
            title: architectureCareerPath?.name || '',
            text: architectureCareerPath?.description || '',
            url: `${window.location.origin}/career-path/${architectureCareerPath?.id}`,
          }}
          fit={scoreSection}
        />
      </Box>
    </Dialog>
  );
};

const dialogStyle: SxProps<Theme> = {
  zIndex: 99999,
  '& .MuiDialog-paper': {
    border: appBorders.backrsBorders.black,
    borderRadius: 4,
    boxShadow: appBorders.backrsDropShadowBorders.black,
  },
};
